<template>
  <v-form ref="formNew" v-model="valid" class="mt-2" :lazy-validation="lazy">
    <v-container>
      <v-layout wrap justify-space-between>
        <v-flex xs12 sm6 px-2>
          <v-text-field
            v-model="userNameNew"
            label="שם פרטי"
            solo
            type="text"
            :rules="nameRules"
            rounded
            outlined
            prepend-inner-icon="mdi-account"
            required
            dense
            data-cy="first-name"
          />
        </v-flex>
        <v-flex xs12 sm6 px-2>
          <v-text-field
            v-model="lastNameNew"
            label="שם משפחה"
            solo
            rounded
            outlined
            type="text"
            :rules="nameRules"
            prepend-inner-icon="mdi-account"
            required
            dense
            data-cy="last-name"
          />
        </v-flex>
      </v-layout>
      <v-layout wrap justify-space-between>
        <v-flex px-2 xs12 sm6 md6 class="p-relative">
          <v-text-field
            v-model="emailNew"
            label="דואר אלקטרוני"
            solo
            type="email"
            rounded
            outlined
            :rules="emailRules"
            dir="auto"
            prepend-inner-icon="mdi-email-outline"
            :disabled="showSpinner"
            autocomplete="off"
            required
            @blur="validateUserExists"
            @focus="alertError = false"
            @copy.prevent
            @input="
              emailValidationNew = '';
              UserExistsMessage = null;
            "
            @cut.prevent
            dense
            data-cy="email"
            ref="emailNew"
          />

          <p
            v-show="alertError"
            class="display-12 mb-0 error-msg primary--text"
            @click="openLogin(emailNew)"
            v-html="UserExistsMessage"
          >
            <!-- שם משתמש קיים במערכת .
            <span class="primary--text pointer-underline open-login">
              להתחברות
            </span> -->
          </p>
          <SmallSpinner
            v-show="showSpinner"
            class="SmallSpinner"
            :top="10"
            :right="15"
          />
        </v-flex>

        <v-flex px-2 xs12 sm6 md6 class="p-relative">
          <v-text-field
            v-model="emailValidationNew"
            outlined
            rounded
            solo
            :rules="emailValidationRules"
            type="text"
            label="הקלד שנית לצורך אימות"
            prepend-inner-icon="mdi-email-outline"
            class="text-field-input"
            ref="emailValidationField"
            required
            @paste.prevent
            autocomplete="new-email"
            dense
            dir="auto"
            :disabled="!isEmailValid || alertError"
          />
        </v-flex>
        <v-flex xs12 sm6 md6 px-2>
          <v-text-field
            v-model="passwordNew"
            type="password"
            label="סיסמה (6 תווים)"
            solo
            :rules="passwordRules"
            rounded
            outlined
            prepend-inner-icon="mdi-lock"
            required
            maxlength="15"
            dense
            data-cy="password"
          />
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12 sm12 md12 id="terms1">
          <v-checkbox
            v-model="rememberMe"
            color="orange"
            class="mt-0"
            hide-details
            light
          >
            <template v-slot:label>
              <div>
                <span>זכור אותי</span>
              </div>
            </template>
          </v-checkbox>
        </v-flex>
      </v-layout>
      <v-layout column wrap>
        <v-flex id="terms2">
          <TermsField @newTerms="acceptTerms" />
        </v-flex>
        <v-flex text-center>
          <v-layout wrap justify-center>
            <v-flex text-center>
              <v-btn
                :loading="registerProcess"
                id="submit-login-btn"
                :disabled="!valid || showSpinner || UserExists"
                class="orange_btn_large"
                @click="validateNewUser"
              >
                המשך לסימון העדפות
              </v-btn>
              {{ isDisabled }}
            </v-flex>
          </v-layout>
          <small v-if="registrationtError" class="d-block my-2 red--text">
            {{ errorSign }}
          </small>
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import SmallSpinner from '@/components/Spinner/SmallSpinner';
import TermsField from '@/components/Forms/Form_Fields/TermsField';
import gtm from '@/lib/gtm';
import errors from '@/lib/errorsList';
import { t } from '@/store/modules/homeDrushim/constantsContent';
import { SIGN_UP, VERIFY_EMAIL } from '@/lib/api.js';
// import recaptchaV3 from '@/components/mixins/recaptchaV3';

export default {
  components: {
    SmallSpinner,
    TermsField
  },
  // mixins: [recaptchaV3],
  data() {
    return {
      lazy: false,
      valid: false,
      alertError: '',
      UserExistsMessage: false,
      showSpinner: false,
      UserExists: false,
      registerProcess: false,
      emailNew: '',
      emailValidationNew: '',
      passwordNew: '',
      userNameNew: '',
      lastNameNew: '',
      cityId: null,
      // catModel: null,
      terms: false,
      rememberMe: true,
      registrationtError: false,
      errorSign: '',

      termsRules: [v => !!v || 'יש לאשר את תנאי השימוש'],
      nameRules: [v => !!v || 'שדה חובה'],
      emailRules: [
        v => !!v || 'שדה חובה',
        v =>
          /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(v) ||
          'כתובת דואר לא חוקית'
      ],
      emailValidationRules: [v => !!v && this.checkEmailValidation()],

      passwordRules: [
        v => !!v || 'שדה חובה',
        v => /^.{6,}$/.test(v) || 'סיסמא לא חוקית'
      ],
      comoRules: [v => !!v || 'שדה חובה']
    };
  },
  head() {
    return {
      title: 'רישום לסוכן החכם | דרושים IL'
    };
  },

  computed: {
    ...mapState({
      // allCategories: (state) => state.homeDrushim.allCategories,
      email: state => state.authUser.smartAgent.firstStepCategory.email,
      cat: state => state.authUser.smartAgent.firstStepCategory.cat
    }),
    ...mapGetters(['categoryCode', 'getCategoryItemByName', 'CurrentUser']),

    isDisabled() {
      return this.$refs.formNew;
    },

    isEmailValid() {
      return /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(
        this.emailNew
      );
    }
  },

  methods: {
    checkEmailValidation() {
      if (this.emailValidationNew.localeCompare(this.emailNew)) {
        return t('titles.errorMessages.emailValidationFailed');
      } else {
        return true;
      }
    },
    acceptTerms(boolVal) {
      this.terms = boolVal;
    },
    openLogin() {
      /**
       * Emit the email to login dialog if user exists
       */
      this.$nuxt.$emit('hasEmail', this.emailNew);

      document.querySelector('.login-btn').click();
    },
    ...mapActions(['addStepOneCategory', 'addStepOneEmail']),
    // addCatToState() {
    //   let selectedCat = this.getCategoryItemByName(this.catModel)
    //   this.addStepOneCategory({ cat: selectedCat })
    // },

    async validateNewUser() {
      // this.addCatToState()
      this.registerProcess = true;
      this.$nuxt.$loading.start();

      if (this.$refs.formNew.validate()) {
        let currentQueryParams =
          this.$route.fullPath.indexOf('?') > -1
            ? this.$route.fullPath.split('?')[1]
            : false;

        currentQueryParams = currentQueryParams ? `?${currentQueryParams}` : '';

        const data = {
          FirstName: this.userNameNew,
          LastName: this.lastNameNew,
          AgreeToTerms: this.terms,
          Email: this.emailNew,
          Password: this.passwordNew,
          RememberMe: this.rememberMe,
          CityId: 1201,
          Source: '2',
          FullSignUp: false
        };

        // this.showSpinner = true;
        // const recaptcha = await this.recaptchaCheck('smartalerts');
        // if (!recaptcha) {
        //   throw 'ERROR => recaptcha';
        // }
        try {
          const response = await this.$axios.post(
            `${SIGN_UP}/${currentQueryParams}`,
            data
          );

          if (response.data.IsError || response.data.Token === '') {
            throw response.data.ErrorsMessages;
          }

          gtm({
            ID: response.data.RegistrationSource.RegistrationIdentifier,
            registration: response.data.RegistrationSource.Source,
            event: 'leadcrmregistration'
          });

          gtm({
            email: this.emailNew,
            phone: '',
            event: 'smart_agent_gads'
          });

          this.$auth
            .loginWith('local', {
              data: {
                email: this.emailNew,
                password: this.passwordNew
              }
            })
            .then(() => {
              if (this.CurrentUser) {
                this.$nuxt.$emit('next-step');
                this.$nuxt.$emit('chosenCat', this.catModel);

                this.$router.push({
                  path: this.$route.path,
                  query: {
                    user_s: 'real_new'
                    // catdir: `cat${this.catCode()}`,
                  }
                });
                /** Goal 5 event #2 - after sign up on first step */
                gtm({
                  page: '/smartalerts/step2',
                  event: 'smartalert'
                });

                /** Goal 1 sign up on smartalerts  */
                gtm({
                  event: 'real_user_smart_agent'
                });

                this.$nuxt.$loading.start();
              } else {
                this.$toast.error('שגיאת התחברות ', { icon: 'error' });
                this.$router.push('/smartalerts.aspx');
              }
              // this.$nuxt.$emit('chosenCat', this.catModel)

              this.$nuxt.$loading.finish();
            });
        } catch (e) {
          console.log(e);

          this.errorSign = errors[Object.keys(e)[0]];

          this.showError = true;
          this.registrationtError = true;
          this.showSpinner = false;
          this.registerProcess = false;
          this.$nuxt.$loading.finish();
        }
      }
    },

    /**
     * @todo share validateUserExists between components
     */
    async validateUserExists() {
      if (!this.$refs.emailNew.hasError) {
        this.showSpinner = true;
        const emailToVerify = encodeURIComponent(this.emailNew);
        try {
          const response = await this.$axios.get(
            `${VERIFY_EMAIL}?email=${emailToVerify}`
          );

          if (response.data.IsError) {
            throw response.data.ErrorsMessages;
          } else {
            this.showSpinner = false;
            this.alertError = false;
            this.UserExists = false;
            this.UserExistsMessage = false;
          }
        } catch (error) {
          let keyNum = Object.keys(error)[0];
          console.log(error, keyNum);
          if (keyNum === '2') {
            this.UserExistsMessage = `שם משתמש קיים במערכת .
            <span class="primary--text pointer-underline open-login">
              להתחברות
            </span>`;
          } else {
            this.UserExistsMessage = errors[keyNum];
            // this.UserExistsMessage = '';
          }
          this.showSpinner = false;
          this.alertError = true;
          this.UserExists = true;
        }
      }
    }
  },

  mounted() {
    // consume email if set (e.g in home page)
    /**
     * Add email value passed from home page .
     * @email stored in vuex
     */
    if (this.email) {
      this.emailNew = this.email;
      this.validateUserExists();
    }

    // consume category name if set
    if (this.cat) {
      this.catModel = this.cat;
      this.addStepOneCategory({ cat: this.catModel });
    }
  }
};
</script>

<style lang="scss" scoped>
div.v-input__slot {
  border-radius: 50px;
  border-color: red;
}

.term-page {
  font-size: 14px;
}
.error-msg {
  position: absolute;
  bottom: 5px;
  right: 20px;
}
</style>
